// searchReducer.js — suggestions dropdown + home trending terms
import * as types from "../types/searchTypes";

const initialState = {
  suggestionStores: [],
  suggestionCoupons: [],
  suggestionsLoading: false,
  suggestionsError: null,
  trendingTerms: [],
  trendingLoading: false,
  trendingError: null,
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SEARCH_SUGGESTIONS_REQUEST:
      return {
        ...state,
        suggestionsLoading: true,
        suggestionsError: null,
      };

    case types.FETCH_SEARCH_SUGGESTIONS_SUCCESS:
      return {
        ...state,
        suggestionsLoading: false,
        suggestionStores: action.payload.stores || [],
        suggestionCoupons: action.payload.coupons || [],
      };

    case types.FETCH_SEARCH_SUGGESTIONS_FAILURE:
      return {
        ...state,
        suggestionsLoading: false,
        suggestionsError: action.payload,
        suggestionStores: [],
        suggestionCoupons: [],
      };

    case types.SEARCH_SUGGESTIONS_CANCELLED:
      return {
        ...state,
        suggestionsLoading: false,
      };

    case types.CLEAR_SEARCH_SUGGESTIONS:
      return {
        ...state,
        suggestionStores: [],
        suggestionCoupons: [],
        suggestionsLoading: false,
        suggestionsError: null,
      };

    case types.GET_SEARCH_TRENDING_TERMS_REQUEST:
      return {
        ...state,
        trendingLoading: true,
        trendingError: null,
      };

    case types.GET_SEARCH_TRENDING_TERMS_SUCCESS:
      return {
        ...state,
        trendingLoading: false,
        trendingTerms: action.payload || [],
      };

    case types.GET_SEARCH_TRENDING_TERMS_FAILURE:
      return {
        ...state,
        trendingLoading: false,
        trendingError: action.payload,
        trendingTerms: [],
      };

    default:
      return state;
  }
};

export default searchReducer;
